import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { BedroomsState } from './types'

const INITIAL_STATE: BedroomsState = {
  error: '',
  list: [],
  loading: false,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendBedroomsError: '',
  sendBedroomsLoading: false,
  total_results: 0
}

const reducer = createReducer<BedroomsState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getBedrooms, state => ({
    ...state,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getBedroomsFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getBedroomsSuccess, (state, { payload }) => ({
    ...state,
    list: [...payload.partner_hotel_rooms],
    loading: false
  }))
  .handleAction(Actions.sendBedrooms, state => ({
    ...state,
    sendBedroomsError: '',
    sendBedroomsLoading: true
  }))
  .handleAction(Actions.sendBedroomsFailure, (state, { payload }) => ({
    ...state,
    sendBedroomsError: payload.message,
    sendBedroomsLoading: false
  }))
  .handleAction(Actions.sendBedroomsSuccess, state => ({
    ...state,
    sendBedroomsLoading: false
  }))

export default reducer
